var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 80 80",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3675 15.5443C20.5509 15.8165 20 16.5808 20 17.4416V72.0001H44V10.775C44 9.40986 42.6626 8.44592 41.3675 8.8776L21.3675 15.5443ZM33.756 43.2782C32.6609 43.4224 31.89 44.427 32.0342 45.5222C32.1784 46.6173 33.183 47.3882 34.2781 47.244L38.2439 46.7219C39.339 46.5777 40.1099 45.5731 39.9658 44.4779C39.8216 43.3828 38.8169 42.6119 37.7218 42.7561L33.756 43.2782Z",
    fill: "#FF4141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 16.0001C41 14.3433 42.3431 13.0001 44 13.0001H58C60.7614 13.0001 63 15.2387 63 18.0001V69.0001H68C69.6569 69.0001 71 70.3433 71 72.0001C71 73.657 69.6569 75.0001 68 75.0001H12C10.3431 75.0001 9 73.657 9 72.0001C9 70.3433 10.3431 69.0001 12 69.0001H41V16.0001ZM47 69.0001H57V19.0001H47V69.0001Z",
    fill: "#FF4141"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.862cf158d5e77ed69b78d22ea372165c.svg";
export { ForwardRef as ReactComponent };